export default __webpack_public_path__ + "static/media/Excellent.cefab6c4.png";